/**
 * Cio' che la verifica **legge**. La schermata non compone percorsi: un refuso
 * in una stringa darebbe un 404 che sembra un difetto del servizio.
 *
 * **Qui non si scrive piu' (GI-172).** `confirm`, `reject` e `undo` diretti non
 * esistono piu' da questa parte. Scrivevano senza gettone e senza versione
 * attesa, quindi potevano decidere esattamente i candidati che un collega aveva
 * appena riservato: il lease distribuiva il lavoro e questa strada lo
 * ridistribuiva addosso. Il servizio ora la rifiuta con
 * `review_protocol_required` dove il protocollo e' richiesto, e la pagina passa
 * dagli intenti (`reviewSync`), che portano gettone, era e versione attesa e
 * sanno dire, dopo una risposta perduta, se il verdetto era arrivato.
 */
import { get } from './api'
import type { OpenedCandidate, Queue, Reason } from './types'

/** La coda della commessa, per conto di una sessione quando ce n'e' una.
 *
 * Senza la sessione il servizio non sa per conto di chi risponde: i candidati
 * che questa scheda ha appena riservato gli risultano presi da qualcun altro,
 * e la coda si apre vuota su lavoro che si ha in mano. */
export function queue(inspectionId: string, reviewSessionId?: string | null): Promise<Queue> {
  const query = new URLSearchParams({ inspection_id: inspectionId })
  if (reviewSessionId) query.set('review_session_id', reviewSessionId)
  return get<Queue>(`/reviews/queue?${query.toString()}`)
}

export function reasons(): Promise<Reason[]> {
  return get<Reason[]>('/reviews/reasons')
}

/** Un candidato per identita', deciso o no.
 *
 * Serve quando l'indirizzo nomina un candidato che la coda non porta: un punto
 * gia' deciso aperto dalla mappa, o uno in mano a un collega. Il banco lo
 * mostra lo stesso, e dice che cosa e' stato deciso. */
export function candidate(detectionId: string): Promise<OpenedCandidate> {
  return get<OpenedCandidate>(`/reviews/candidates/${encodeURIComponent(detectionId)}`)
}
